import { reactive } from 'vue';

export default class Timer {
	/**
	 * mono confirm timer
	 * @param startTime - start timer seconds
	 */
	constructor(startTime) {
		this.timer = null;
		this._model = reactive({
			time: startTime,
		});
		this.timerCounter = this.timerCounter.bind(this);

		this.start();
	}

	/**
	 * get counter
	 * @returns {*}
	 */

	get time() {
		return this._model.time;
	}

	/**
	 * set time
	 * @param time
	 */

	set time(time) {
		this._model.time = time;
	}

	/**
	 * format timer function
	 * @returns {string|*}
	 */
	formatTime(time) {
		return time < 10 ? '0' + time : time;
	}

	/**
	 * get format minutes
	 * @returns {string|*}
	 */
	get getMinutes() {
		return this.formatTime(Math.floor(this.time / 60));
	}

	/**
	 * get format seconds
	 * @returns {string}
	 */
	get getSeconds() {
		return this.formatTime(this.time % 60);
	}

	/**
	 * decrease counter
	 */

	timerCounter() {
		if (this.time > 0) {
			this.time = this.time - 1;
			this.timer = setTimeout(this.timerCounter, 1000);
		} else {
			// console.log('stop!!!');
		}
	}

	/**
	 * stop timer
	 */
	stop() {
		clearTimeout(this.timer);
	}

	/**
	 * start
	 */

	start() {
		this.timer = setTimeout(this.timerCounter, 1000);
	}
}